import { useEffect, useRef, useCallback } from 'react'

function useTimeout(fn, ms = 0, open = true) {
	const timeout = useRef()

	const clear = useCallback(() => {
		timeout.current && clearTimeout(timeout.current)
	}, [])

	const set = useCallback(() => {
		if (timeout.current) {
			clearTimeout(timeout.current)
			timeout.current = null
		}
		if (!open) {
			return
		}
		timeout.current = setTimeout(() => fn?.(), ms)
	}, [ms, fn, open])

	useEffect(() => {
		set()
		return () => {
			if (timeout.current) {
				clearTimeout(timeout.current)
				timeout.current = null
			}
		}
	}, [fn, ms, open, set])

	return { clear, reset: set }
}

export default useTimeout
